module.exports = __webpack_public_path__ + "static/media/Admin.ccb943c1.svg";